import '../public/app/routes/audit_route';
import '../public/app/routes/car_loader_route';
import '../public/app/routes/company_request_route';
import '../public/app/routes/company_route';
import '../public/app/routes/error_route';
import '../public/app/routes/generalConditions_route';
import '../public/app/routes/holiday_route';
import '../public/app/routes/impersonate_route';
import '../public/app/routes/otherwise_route';
import '../public/app/routes/pickupPoint_route';
import '../public/app/routes/pointofsale_route';
import '../public/app/routes/reviews_route';
import '../public/app/routes/routes_config';
import '../public/app/routes/special_offer_route';
import '../public/app/routes/template_route';
import '../public/app/rate/rate.route';
import '../public/app/rate/rate_controller';
import '../public/app/rate/rate_service';
import '../public/app/price-and-availability/priceAndAvailability_controller';
import '../public/app/price-and-availability/price_and_availability_route';
import '../public/app/opaque-rate/opaque-rate-add.component';
import '../public/app/opaque-rate/opaque-rate-ga-config.component';
import '../public/app/opaque-rate/opaque-rate.component';
import '../public/app/opaque-rate/opaque-rate.route';
import '../public/app/opaque-rate/opaque-rate.service';
import '../public/app/opaque-rate/opaque-rates.component';
import '../public/app/opaque-rate/opaque-rate-card/opaque-rate-card.directive';
import '../public/app/models/additional_price_service';
import '../public/app/models/alfred_service';
import '../public/app/models/booking_service';
import '../public/app/models/cache_service';
import '../public/app/models/cfa_service';
import '../public/app/models/company_request_service';
import '../public/app/models/company_service';
import '../public/app/models/data_service';
import '../public/app/models/date_service';
import '../public/app/models/fleet_service';
import '../public/app/models/fleet_upgrade_service';
import '../public/app/models/ga_service';
import '../public/app/models/geo_coder';
import '../public/app/models/geo_service';
import '../public/app/models/holiday_service';
import '../public/app/models/hotjar_service';
import '../public/app/models/insurance_price_service';
import '../public/app/models/item_selector';
import '../public/app/models/logout_service';
import '../public/app/models/modification_policies_service';
import '../public/app/models/one_way_service';
import '../public/app/models/page_service';
import '../public/app/models/pickupPoint_service';
import '../public/app/models/pointofsale_service';
import '../public/app/models/rangeDiscount_service';
import '../public/app/models/range_definition_service';
import '../public/app/models/resource_service';
import '../public/app/models/review_ga_config_service';
import '../public/app/models/reviews_service';
import '../public/app/models/sites_service';
import '../public/app/models/special_offer_ga_config_service';
import '../public/app/models/special_offer_service';
import '../public/app/models/special_offer_urls_service';
import '../public/app/models/users_service';
import '../public/app/models/interceptors/request_interceptor';
import '../public/app/models/directives/bazil_category_banner_directive';
import '../public/app/models/directives/category_banner_directive';
import '../public/app/models/directives/characters_directive';
import '../public/app/models/directives/click_and_disable';
import '../public/app/models/directives/double_date_directive';
import '../public/app/models/directives/input_meter_directive';
import '../public/app/models/directives/item_selector_directive';
import '../public/app/models/directives/map_directive';
import '../public/app/models/directives/markup_notification_directive';
import '../public/app/models/directives/notifications_directive';
import '../public/app/models/directives/number_utils_directives';
import '../public/app/models/directives/pos_selector_directive';
import '../public/app/models/directives/requireiftrue_directive';
import '../public/app/models/directives/review_directive';
import '../public/app/models/directives/review_filter_directive';
import '../public/app/models/directives/review_summary_directive';
import '../public/app/models/directives/specialoffer_card_directive';
import '../public/app/markup/markup-ga-config.service';
import '../public/app/markup/markup.component';
import '../public/app/markup/markup.route';
import '../public/app/markup/markup.service';
import '../public/app/language-selector/language-selector.component';
import '../public/app/fleet/fleet.component';
import '../public/app/fleet/fleet.route';
import '../public/app/controllers/application_controller';
import '../public/app/controllers/audit_controller';
import '../public/app/controllers/carLoader_controller';
import '../public/app/controllers/companyRequest_controller';
import '../public/app/controllers/company_controller';
import '../public/app/controllers/error_controller';
import '../public/app/controllers/holiday_controller';
import '../public/app/controllers/impersonate_controller';
import '../public/app/controllers/moderate_controller';
import '../public/app/controllers/language_controller';
import '../public/app/controllers/pickupPoints_controller';
import '../public/app/controllers/pointsofsale_controller';
import '../public/app/controllers/reviews_controller';
import '../public/app/controllers/special_offer_controller';
import '../public/app/controllers/special_offer_upgrade_controller';
import '../public/app/controllers/special_offers_controller';
import '../public/app/controllers/general_conditions_controllers/additional_price_controller';
import '../public/app/controllers/general_conditions_controllers/additionals_price_controller';
import '../public/app/controllers/general_conditions_controllers/insurances_price_controller';
import '../public/app/controllers/general_conditions_controllers/modification_policies_controller';
import '../public/app/controllers/general_conditions_controllers/one_way_controller';
import '../public/app/controllers/general_conditions_controllers/range_definition_controller';
import '../public/app/controllers/fleet_controllers/car_controller';
import '../public/app/contract/contract_controller';
import '../public/app/contract/contract_route';
import '../public/app/contract/contract_service';
import '../public/app/contract/contract_states_services';
import '../public/app/contract/contracts_controller';
import '../public/app/contract/legal_document_service';
import '../public/app/contract/viewTermAndConditions_controller';
import '../public/app/commons/switch/switch.component';
import '../public/app/commons/form/stepper/stepper.component';
import '../public/app/commons/form/input/input.component';
import '../public/app/commons/form/card/card.component';
import '../public/app/commons/click-and-wait/click-and-wait.directive';
import '../public/app/availability/availability.route';
import '../public/app/availability/availability_controller';
import '../public/app/availability/availability_service';
import '../public/app/alert-emails/alert-email.component';
import '../public/app/alert-emails/alert-email.service';
import '../public/app/alert-emails/alert-emails.component';
import '../public/app/alert-emails/alert-emails.route';



//////////////////
// WEBPACK FOOTER
// ./config/imports.js
// module id = 807
// module chunks = 3